import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import ServicesLanding from "../views/ServicesLanding";
import Software from "../views/services/Software";
import WebDev from "../views/services/WebDev";
import SystemDev from "../views/services/SystemDev";
import Tax from "../views/services/Tax";
import Enterprise from "../views/services/Enterprise";

export default function Services() {
  const appContext = useContext(AppContext);
  const [view, setView] = useState(null);

  async function init() {
    // run initializations here
  }

	function getView() {
		if(
			!appContext.navSubItem &&
			!appContext.navExtraItem &&
			!appContext.navMoreItem
		) {
			return <ServicesLanding/>
		} else if (
			appContext.navSubItem === 'software' &&
			!appContext.navExtraItem &&
			!appContext.navMoreItem
		) {
			return <Software/>
		} else if (
			appContext.navSubItem === 'software' &&
			appContext.navExtraItem === 'webDev' &&
			!appContext.navMoreItem
		) {
			return <WebDev/>
		} else if (
			appContext.navSubItem === 'software' &&
			appContext.navExtraItem === 'systemDev' &&
			!appContext.navMoreItem
		) {
			return <SystemDev/>
		} else if (
			appContext.navSubItem === 'software' &&
			appContext.navExtraItem === 'appDev' &&
			!appContext.navMoreItem
		) {
			return <Software/>
		} else if (
			appContext.navSubItem === 'tax-compliance' &&
			!appContext.navExtraItem &&
			!appContext.navMoreItem
		) {
			return <Tax/>
		} else if (
			appContext.navSubItem === 'enterprise' &&
			!appContext.navExtraItem &&
			!appContext.navMoreItem
		) {
			return <Enterprise />
		} 
			return null;
	}

  useEffect(() => {
    init();
  }, []);

  useEffect(() => {
    if (
      appContext.navSubItem === 'software' &&
      appContext.navExtraItem === 'appDev' &&
      !appContext.navMoreItem
    ) {
      window.location.replace('#/view/software/appDev/');
    }
  }, [appContext.navSubItem, appContext.navExtraItem, appContext.navMoreItem]);

  useEffect(() => {
    const nextView = getView();
    if (nextView) {
      setView(nextView);
    }
  }, [appContext.navSubItem, appContext.navExtraItem, appContext.navMoreItem]);

  return view;
}
